import {
  Box,
  Button,
  Flex,
  Grid,
  Icon,
  Image,
  Menu,
  MenuButton,
  MenuDivider,
  MenuGroup,
  MenuItem,
  MenuList,
  Stack,
  theme,
  useColorMode,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";

import { useContext, useState } from "react";
import { AiOutlineAim } from "react-icons/ai";
import { FaRobot } from "react-icons/fa";
import { LiaMoneyBillWaveAltSolid, LiaToolsSolid } from "react-icons/lia";
import {
  MdDataUsage,
  MdFormatListNumbered,
  MdOutlineLogout,
  MdOutlineWebhook,
  MdSupportAgent,
} from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";

import { IoKeyOutline, IoLibraryOutline, IoSyncSharp } from "react-icons/io5";
import {
  liveAgents,
  navItemsData_1,
  navItemsData_5,
} from "../../utils/Data/data";
import { clipText } from "../../utils/utils";
import AuthContext from "../Auth/AuthContext";
import InstructionModal from "../Modals/InstructionModal";
import { AgencyContext } from "../Settings/AgencyProvider/AgencyProvider";
import NavItem from "./NavItem";
import { NAVBAR_ITEMS } from "./contants";
import { LuNetwork, LuSquareFunction } from "react-icons/lu";
import { FaRegCircleUser } from "react-icons/fa6";
import { TbApi } from "react-icons/tb";
import { ChevronRightIcon } from "@chakra-ui/icons";
import { GrSystem } from "react-icons/gr";
import { RiDiscordLine } from "react-icons/ri";
import { BiSupport } from "react-icons/bi";
import { FiExternalLink } from "react-icons/fi";
import SidebarWallet from "./SidebarWallet";

export function SidebarUserDetails(props) {
  const navigate = useNavigate();
  const { authUser, logout } = useContext(AuthContext);

  const userRoles = authUser?.roles || [];
  const isSuperAdmin =
    userRoles.includes("superadmin") || authUser?.is_superuser;

  const logoutUser = () => {
    logout();
    localStorage.removeItem("announced");
  };

  const agency = useContext(AgencyContext);

  const { buttonColorScheme, myDetails } = agency;

  const isDocsAndDiscordVisible = agency.loading
    ? false
    : myDetails?.agency_id
    ? myDetails?.branding?.socials?.discord ||
      myDetails?.branding?.socials?.docs
      ? true
      : false
    : true;

  const renderUserName = () => {
    const { navSize, userName, user } = props;

    if (navSize !== "small") {
      if (userName) {
        return userName;
      }
      if (user?.email) {
        return user.email;
      }
      return "Your Account";
    } else {
      return "";
    }
  };
  const handleMenuClick = (path) => {
    navigate(path);
  };

  const settingsItems = [
    { label: "Profile", icon: FaRegCircleUser, path: "/settings/profile" },
    // { label: "Channels", icon: MdSocialDistance, path: "/settings/channels" },
    { label: "Webhooks", icon: MdOutlineWebhook, path: "/settings/webhooks" },
    { label: "Usage", icon: MdDataUsage, path: "/settings/usage" },
    {
      label: agency?.myDetails?.agency_id ? "Billing" : "Billing & Wallet",
      icon: LiaMoneyBillWaveAltSolid,
      path: "/settings/billing",
    },
    { label: "API Keys", icon: TbApi, path: "/settings/api-keys" },
    {
      label: "Your Provider Keys",
      icon: IoKeyOutline,
      path: "/settings/your-keys",
    },
  ];

  if (isSuperAdmin) {
    settingsItems.push({
      label: "Manage Human Agents",
      icon: MdSupportAgent,
      path: "/settings/agents",
    });
  }

  const logsItems = [
    { label: "System Logs", icon: GrSystem, path: "/logs/system_log" },
    {
      label: "Tool Function Calls",
      icon: LuSquareFunction,
      path: "/logs/tool_function_invoke_log",
    },
    {
      label: "CRM Sync",
      icon: IoSyncSharp,
      path: "/logs/contact_sync_log",
    },
  ];

  const onClickDiscord = () => {
    const link =
      agency?.myDetails?.branding?.socials?.discord ||
      "https://discord.gg/3baqJDqGYQ";
    window.open(link, "_blank");
  };
  const onClickFreshDesk = () => {
    const link =
      agency?.myDetails?.branding?.socials?.docs || "https://docs.insighto.ai/";
    window.open(link, "_blank");
  };
  const onClickAffiliate = () => {
    window.open("https://affiliates.insighto.ai/program", "_blank");
  };

  const menuItems = [
    {
      label: "Discord",
      value: onClickDiscord,
      icon: RiDiscordLine,
      isVisible: agency?.myDetails?.branding?.socials?.discord || true,
    },
    {
      label: "Docs",
      value: onClickFreshDesk,
      icon: BiSupport,
      isVisible: agency?.myDetails?.agency_id ? false : true,
    },
    {
      label: "Affiliate ",
      value: onClickAffiliate,
      icon: FiExternalLink,
      isVisible: agency?.myDetails?.agency_id ? false : true,
    },
  ];
  const filterMenuItem = menuItems.filter((item) => item.isVisible);
  const isActive = (path) =>
    window.location.pathname.includes(path) ? true : false;
  const textColor = agency?.textColor;
  const iconColor = useColorModeValue(
    textColor || theme.colors.gray[500],
    "white"
  );
  const { colorMode } = useColorMode();

const isSalesBtnisvisible = agency.loading
  ? false
  : myDetails?.agency_id
  ? myDetails?.wallet === true
  : true;

  return (
    <Grid w={"100%"} gap={2} p={2}>
      {isSalesBtnisvisible && (
        <SidebarWallet />
      )}

      <Stack direction="row" spacing={6} width={"100%"}>
        <Menu placement="right-end">
          <MenuButton
            as={Button}
            width="100%"
            colorScheme={buttonColorScheme}
            rightIcon={<ChevronRightIcon />}
            variant="solid"
            justifyContent="space-between"
          >
            {clipText(renderUserName(), 20)}
          </MenuButton>
          <MenuList
            maxH="98vh"
            overflow="hidden"
            p={0} // Remove default padding so scrolling looks clean
          >
            <Box
              maxH="98vh"
              overflowY="auto"
              className="sidebar-menu-scroll" // optional if you want custom scrollbar
            >
              <MenuGroup title="Settings">
                {settingsItems.map((item) => (
                  <MenuItem
                    key={item.label}
                    icon={<Icon as={item.icon} />}
                    onClick={() => handleMenuClick(item.path)}
                    borderRight={
                      isActive(item.path) && `3px solid ${iconColor}`
                    }
                    color={
                      colorMode === "light"
                        ? isActive(item.path)
                          ? textColor
                          : "black"
                        : isActive(item.path)
                        ? "white"
                        : "gray.300"
                    }
                  >
                    {item.label}
                  </MenuItem>
                ))}
              </MenuGroup>

              <MenuDivider />

              <MenuGroup title="Logs">
                {logsItems.map((item) => (
                  <MenuItem
                    key={item.label}
                    icon={<Icon as={item.icon} />}
                    onClick={() => handleMenuClick(item.path)}
                    borderRight={
                      isActive(item.path) && `3px solid ${iconColor}`
                    }
                    color={
                      colorMode === "light"
                        ? isActive(item.path)
                          ? textColor
                          : "black"
                        : isActive(item.path)
                        ? "white"
                        : "gray.300"
                    }
                  >
                    {item.label}
                  </MenuItem>
                ))}
              </MenuGroup>

              {isDocsAndDiscordVisible && (
                <>
                  <MenuDivider />
                  <MenuGroup title="Help">
                    {filterMenuItem.map((item) => (
                      <MenuItem
                        key={item.label}
                        icon={<Icon as={item.icon} />}
                        onClick={() => item.value()}
                        color={colorMode === "dark" ? "gray.300" : "black"}
                      >
                        {item.label}
                      </MenuItem>
                    ))}
                  </MenuGroup>
                </>
              )}

              <MenuDivider />
              <MenuItem
                icon={<MdOutlineLogout />}
                onClick={logoutUser}
                color="red.500"
              >
                Logout
              </MenuItem>
            </Box>
          </MenuList>
        </Menu>
      </Stack>
    </Grid>
  );
}

export default function SideBar() {
  const [navSize] = useState("large");
  const navigate = useNavigate();

  const { authUser, logout } = useContext(AuthContext);

  const { isOpen, onClose } = useDisclosure();
  const handleItemClick = (path) => {
    navigate(path);
  };
  const onClickLogout = () => {
    logout();
  };

  const userName =
    authUser?.first_name?.length > 15
      ? `${authUser?.first_name?.slice(0, 10)}...`
      : authUser?.first_name;

  function AIAgentsTab() {
    const location = useLocation();
    return (
      <Box borderRadius={"md"}>
        <Box onClick={() => handleItemClick("/ai-agents")}>
          <NavItem
            toolTip={
              "AI Agent helps you add your dataset, train your assistant, configure intents & launch widgets with ease."
            }
            navSize={navSize}
            icon={FaRobot}
            active={location.pathname.startsWith("/ai-agents")}
            title={"AI Agents"}
          />
        </Box>
        {NAVBAR_ITEMS.some((path) => location.pathname.startsWith(path)) ? (
          <ul
            style={{
              listStyle: "none",
              paddingLeft: 10,
            }}
          >
            <li onClick={() => handleItemClick("/conversation-flow")}>
              <NavItem
                size="small"
                toolTip={"Configure conversation flow"}
                navSize={navSize}
                icon={LuNetwork}
                active={location.pathname.startsWith("/conversation-flow")}
                title={"Conversation Flow"}
              />
            </li>
            <li onClick={() => handleItemClick("/forms")}>
              <NavItem
                size="small"
                toolTip={"Configure the forms"}
                navSize={navSize}
                icon={MdFormatListNumbered}
                active={location.pathname.startsWith("/forms")}
                title={"Forms"}
              />
            </li>
            <li onClick={() => handleItemClick("/intents")}>
              <NavItem
                size="small"
                toolTip={"Configure your intents here"}
                navSize={navSize}
                icon={AiOutlineAim}
                active={location.pathname.startsWith("/intents")}
                title={"Intents"}
              />
            </li>
            <li onClick={() => handleItemClick("/tools")}>
              <NavItem
                size="small"
                toolTip={"Configure different tools"}
                navSize={navSize}
                icon={LiaToolsSolid}
                active={location.pathname.startsWith("/tools")}
                title={"Tools"}
              />
            </li>
            <li onClick={() => handleItemClick("/library/prompts")}>
              <NavItem
                size="small"
                toolTip={"Configure libraries"}
                navSize={navSize}
                icon={IoLibraryOutline}
                active={location.pathname.startsWith("/library")}
                title={"Library"}
              />
            </li>
            <li onClick={() => handleItemClick("/voices")}>
              <NavItem
                size="small"
                toolTip={"Configure Voices"}
                navSize={navSize}
                icon={LiaToolsSolid}
                active={location.pathname.startsWith("/voices")}
                title={"Voices"}
              />
            </li>
          </ul>
        ) : null}
      </Box>
    );
  }

  const agency = useContext(AgencyContext);
  const { myDetails } = agency;
  const agencyLogoUrl = myDetails ? myDetails?.branding?.logo_url : null;
  const logo = !agency.loading ? (
    myDetails?.agency_id ? (
      agencyLogoUrl ? (
        <Image
          width="100px"
          src={
            agencyLogoUrl.includes(window.origin)
              ? agencyLogoUrl
              : `${window.location.origin}${agencyLogoUrl}`
          }
          alt={`${myDetails?.branding?.agency_name}-logo`}
        />
      ) : null
    ) : (
      <Image width="150px" src="/logo/indightoai.png" alt="Insighto.ai" />
    )
  ) : null;
  const userRoles = authUser?.roles || [];
  const isAgent = userRoles.includes("agent") && userRoles?.length === 1;
  return (
    <div className="sidebar">
      <Flex
        h={"100svh"}
        boxShadow="md"
        borderRadius={navSize === "small" ? "8px" : "8px"}
        w={navSize === "small" ? "75px" : "240px"}
        flexDir="column"
        overflowY={"auto"}
        justifyContent="space-between"
      >
        <Grid>
          <Flex p={2} justifyContent={"center"} alignItems="center" gap={3}>
            <div
              style={{
                display: navSize === "small" ? "none" : "block",
                color: "#3182ce",
              }}
            >
              {logo}
            </div>
          </Flex>
          <div>
            {!isAgent ? (
              <>
                {navItemsData_1.map((item, index) => (
                  <div key={index} onClick={() => handleItemClick(item.path)}>
                    <NavItem
                      toolTip={item.toolTip}
                      navSize={navSize}
                      icon={item.icon}
                      active={item.path === window.location.pathname}
                      title={item.title}
                      description={item.description}
                    />
                  </div>
                ))}
                <hr />
                <AIAgentsTab />
                <hr />
                {navItemsData_5
                  .filter((item) =>
                    agency?.myDetails?.agency_id
                      ? item.title !== "Agency" && item.title !== "Campaigns"
                      : true
                  )
                  .map((item, index) => (
                    <div key={index} onClick={() => handleItemClick(item.path)}>
                      <NavItem
                        toolTip={item.toolTip}
                        navSize={navSize}
                        icon={item.icon}
                        active={window.location.pathname.includes(item.path)}
                        title={item.title}
                        description={item.description}
                      />
                    </div>
                  ))}
              </>
            ) : null}
            <hr />
            {liveAgents.map((item, index) => (
              <div key={index} onClick={() => handleItemClick(item.path)}>
                <NavItem
                  toolTip={item.toolTip}
                  navSize={navSize}
                  icon={item.icon}
                  active={window.location.pathname.includes(item.path)}
                  title={item.title}
                  description={item.description}
                />
              </div>
            ))}
            <hr />
          </div>
        </Grid>
        {!isAgent ? (
          <>
            <InstructionModal onClose={onClose} isOpen={isOpen} />
            <SidebarUserDetails
              navSize={navSize}
              user={authUser}
              onClickLogout={onClickLogout}
              userName={userName}
            />
          </>
        ) : null}
      </Flex>
    </div>
  );
}
